import {
  IPriceSnapshotActions,
  PriceSnapshotContext,
  IFetchPriceSnapshotsActionPayload
} from './actions.types';
import { IPriceSnapshotData, ICustomerPricingData } from '@/models';
import { IPriceSnapshotPaginatedListData } from '@/services';

export const actions: IPriceSnapshotActions = {
  fetchPriceSnapshots(
    context: PriceSnapshotContext,
    payload: IFetchPriceSnapshotsActionPayload
  ): Promise<void> {
    return this.$services.priceSnapshot
      .fetchPriceSnapshots(payload.page, payload.search)
      .then((pricesnapshotData: IPriceSnapshotPaginatedListData) => {
        context.commit('SET_PRICESNAPSHOTS', pricesnapshotData.results);
        context.commit('SET_COUNT', pricesnapshotData.count);
      });
  },

  fetchPriceSnapshot(
    context: PriceSnapshotContext,
    payload: number
  ): Promise<void> {
    return this.$services.priceSnapshot
      .fetchPriceSnapshot(payload)
      .then((pricesnapshot: IPriceSnapshotData) => {
        const index = context.state.priceSnapshots.findIndex(
          (v: IPriceSnapshotData) => v.id === pricesnapshot.id
        );
        if (index === -1) {
          context.commit('ADD_PRICESNAPSHOT', pricesnapshot);
          context.commit('INCREMENT_COUNT');
        } else {
          context.commit('UPDATE_PRICESNAPSHOT', pricesnapshot);
        }
      });
  },

  createPriceSnapshot(
    context: PriceSnapshotContext,
    payload: IPriceSnapshotData
  ): Promise<void> {
    return this.$services.priceSnapshot
      .createPriceSnapshot(payload)
      .then((pricesnapshot: IPriceSnapshotData) => {
        context.commit('ADD_PRICESNAPSHOT', pricesnapshot);
        context.commit('INCREMENT_COUNT');
      });
  },

  updatePriceSnapshot(
    context: PriceSnapshotContext,
    payload: IPriceSnapshotData
  ): Promise<void> {
    return this.$services.priceSnapshot
      .updatePriceSnapshot(payload)
      .then((pricesnapshot: IPriceSnapshotData) => {
        const index = context.state.priceSnapshots.findIndex(
          (v: IPriceSnapshotData) => v.id === pricesnapshot.id
        );
        if (index === -1) {
          context.commit('ADD_PRICESNAPSHOT', pricesnapshot);
          context.commit('INCREMENT_COUNT');
        } else {
          context.commit('UPDATE_PRICESNAPSHOT', pricesnapshot);
        }
      });
  },

  deletePriceSnapshot(
    context: PriceSnapshotContext,
    payload: number
  ): Promise<void> {
    return this.$services.priceSnapshot
      .deletePriceSnapshot(payload)
      .then(() => {
        context.commit('REMOVE_PRICESNAPSHOT', payload);
        context.commit('DECREMENT_COUNT');
      });
  },

  assignCustomerSnapshot(
    context: PriceSnapshotContext,
    payload: ICustomerPricingData
  ): Promise<void> {
    return this.$services.priceSnapshot.assignCustomerSnapshot(payload);
  }
};
